import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quantity__row" }
const _hoisted_2 = { class: "quantity-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }

import { computed } from "vue";
import { Direction, PassengerType } from "@/models/Enums";
import { usePassengerStore } from "@/store/passengerStore";
import { VQuantity } from "v-ferry-components";

type PassengerOption = {
  label: string;
  description: string;
  passengerType: PassengerType;
  resourceCode: string;
  resourceType: string;
  type: string;
};

interface Props {
  direction: Direction;
  option: PassengerOption;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PassengerSelectRow',
  props: {
    direction: {},
    option: {}
  },
  setup(__props: any) {

const props = __props;

const { getPassengers, setPassenger } = usePassengerStore();

const passengerCount = computed(() => {
  const passengers = getPassengers(props.direction);
  return passengers.filter(
    (p) => p.passengerType === props.option.passengerType
  ).length;
});

const inputValue = computed({
  get(): number {
    return passengerCount.value;
  },
  set(number: number) {
    setPassenger(props.direction, {
      passengerType: props.option.passengerType,
      amount: number,
    });
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.option.label), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.option.description), 1)
    ]),
    _createVNode(_unref(VQuantity), {
      class: "base-quantity",
      id: "adult",
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      minValue: 0,
      maxValue: 12
    }, null, 8, ["modelValue"])
  ]))
}
}

})